export type SortFilterMode = 'sort' | 'filter'

export type SortFilterPreviewState = 'default' | 'open'

export type SortFilterOption = {
  id: string
  label: string
}

export type SortFilterSection = {
  id: string
  title: string
  options: SortFilterOption[]
}

type SortFilterBaseProps = {
  darkMode?: boolean
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: (open: boolean) => void
  previewState?: SortFilterPreviewState
  disabled?: boolean
  className?: string
  ariaLabel?: string
}

export type SortFilterSortProps = SortFilterBaseProps & {
  mode: 'sort'
  sections: SortFilterSection[]
  values: Record<string, string>
  onChange?: (sectionId: string, optionId: string) => void
}

export type SortFilterFilterProps = SortFilterBaseProps & {
  mode: 'filter'
  title?: string
  options: SortFilterOption[]
  selectedIds: string[]
  onChange?: (selectedIds: string[]) => void
}

export type SortFilterProps = SortFilterSortProps | SortFilterFilterProps

export const SORT_FILTER_PREVIEW_STATES: SortFilterPreviewState[] = [
  'default',
  'open',
]

export const SORT_FILTER_PREVIEW_STATE_LABELS: Record<
  SortFilterPreviewState,
  string
> = {
  default: 'Default',
  open: 'Open',
}

/** Default Files-style sort sections matching the DS. */
export const SORT_FILTER_DEFAULT_SORT_SECTIONS: SortFilterSection[] = [
  {
    id: 'sortBy',
    title: 'Sort by',
    options: [
      { id: 'name', label: 'Name' },
      { id: 'dateModified', label: 'Date modified' },
      { id: 'fileType', label: 'File type' },
    ],
  },
  {
    id: 'order',
    title: 'Order',
    options: [
      { id: 'ascending', label: 'Ascending' },
      { id: 'descending', label: 'Descending' },
    ],
  },
]

/** Default Files-style filter options matching the DS. */
export const SORT_FILTER_DEFAULT_FILTER_OPTIONS: SortFilterOption[] = [
  { id: 'name', label: 'Name' },
  { id: 'fileType', label: 'File type' },
  { id: 'dateModified', label: 'Date modified' },
]
